// Stops best-effort al descargar la pagina (cerrar pestana, navegar afuera,
// refresh). Sin esto, el POST /stop normal (XHR) nunca llega a salir cuando la
// pestana muere y el backend queda con refcounts fantasma: los streams se
// acumulaban para siempre en go2rtc (~100/dia medidos en produccion).
//
// Se usa fetch({keepalive:true}) y NO navigator.sendBeacon porque el beacon no
// permite el header Authorization que exigen /streams/stop y /playback/stop.
// El navegador garantiza (best-effort) que un fetch keepalive sobrevive al
// unload. pagehide es el evento correcto: cubre cierre/navegacion/refresh y
// NO se dispara al cambiar de pestana o minimizar (visibilitychange si).
//
// El registro vive aca (modulo singleton) y lo alimentan los wrappers de
// api/streams.ts y api/playback.ts: cualquier camino que arranque un stream
// (Vivo, Guardia Virtual, swap de subtipo, playback multicam) pasa por ellos.
import { useAuthStore } from "../store/authStore";

type StopKind = "stream" | "playback";

const active = new Map<string, StopKind>();
let installed = false;

function ensureInstalled() {
  if (installed) return;
  installed = true;
  window.addEventListener("pagehide", flush);
}

export function trackStream(streamId: string) {
  active.set(streamId, "stream");
  ensureInstalled();
}

export function untrackStream(streamId: string) {
  active.delete(streamId);
}

export function trackPlayback(playbackId: string) {
  active.set(playbackId, "playback");
  ensureInstalled();
}

export function untrackPlayback(playbackId: string) {
  active.delete(playbackId);
}

function flush() {
  if (active.size === 0) return;
  const token = useAuthStore.getState().accessToken;
  if (!token) {
    active.clear();
    return;
  }
  for (const [id, kind] of active) {
    const path = kind === "playback" ? "/api/v1/playback/stop" : "/api/v1/streams/stop";
    const body =
      kind === "playback"
        ? { playback_id: id, action: "stop" }
        : { stream_id: id };
    try {
      void fetch(path, {
        method: "POST",
        keepalive: true,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });
    } catch {
      // best-effort: si el navegador lo rechaza, el reconciliador del backend
      // limpia el stream huerfano tras la gracia.
    }
  }
  active.clear();
}
